import React from 'react';
import { useRequireAuth } from './useRequireAuth';
import { notification } from 'antd';
import { RouteEnum } from '../modules/account/constantes/RouteEnum';

interface PrivateRouteProps {
  element: React.ReactElement;
  redirectPath?: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  element,
  redirectPath = RouteEnum.LOGIN_USERNAME
}) => {
  const notificationShown = React.useRef(false);
  
  const { user, isLoading } = useRequireAuth({
    redirectPath,
    onRedirect: () => {
      if (!notificationShown.current) {
        notificationShown.current = true;
        notification.warning({
          message: 'Acesso Restrito',
          description: 'Para acessar o sistema é necessário fazer login'
        });
      }
    }
  });

  if (isLoading) {
    return <div></div>;
  }

  if (!user) {
    return null;
  }

  return element;
};

export default React.memo(PrivateRoute);
